<div class="flex flex-col bg-white h-full">
  <div class="w-full relative">
    @if (isLoading()) {
      <div class="w-full absolute">
        <mat-progress-bar
          data-cy="map-list-loader"
          class="mds-x-small"
          [mode]="'indeterminate'"
        ></mat-progress-bar>
      </div>
    }
  </div>
  <div class="flex pl-3 pr-4 py-2 border-b border-gray-1">
    <div class="flex flex-col w-[210px] text-lg font-medium">
      {{ title() }}
      <mat-select
        id="map-list-filter"
        class="modus-dropdown"
        panelClass="modus-dropdown-panel fit-content"
        [formControl]="filterOptionControl"
        disableRipple
      >
        <mat-option [value]="mapFilterOption.All">{{
          translations.filterOptions.allData.text
        }}</mat-option>
        <mat-option [value]="mapFilterOption.LocatedOnly">{{
          translations.filterOptions.georeferencedOnly.text
        }}</mat-option>
      </mat-select>
    </div>

    <div class="flex flex-auto justify-end items-center">
      <sd-scandata-sort-menu
        [sortInfo]="sortInfo()"
        (onSortClick)="sortChanged.emit($event)"
      ></sd-scandata-sort-menu>
    </div>
  </div>

  @if (scanLoadError()) {
    <modus-alert
      class="w-full block p-4"
      [message]="translations.error.loadingData.text"
      type="error"
    ></modus-alert>
  }

  <div class="overflow-y-auto pt-1 pb-3" cdkScrollable data-cy="map-list-scrollable">
    @for (item of scanList(); track item.scan.id) {
      <div
        [ngClass]="{ 'text-trimble-blue bg-blue-pale': item.scan.selected }"
        (click)="onRowClick($event, item.scan)"
        class="flex flex-row items-center cursor-pointer hover:bg-gray-0 py-0.5 pl-[0.4rem] pr-2 select-none"
      >
        <modus-checkbox
          id="map-list-toggle-check"
          class="scale-[0.85]"
          [checked]="item.scan.selected"
          (keydown.enter)="onCheckboxKeyDown(item.scan)"
          (keydown.space)="onCheckboxKeyDown(item.scan); $event.preventDefault()"
        >
        </modus-checkbox>
        <div
          modus-tooltip="{{ item.scan.name }}"
          class="w-full overflow-hidden ml-[0.2rem] text-sm"
        >
          <div
            class="w-full overflow-hidden text-ellipsis whitespace-nowrap"
            [ngClass]="{
              'text-red': item.hasError,
              'text-gray-6': item.notReady,
              'font-semibold': item.scan.selected,
            }"
          >
            {{ item.scan.name }}
          </div>
          <div
            class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-small italic text-gray-6"
          >
            {{ item.message }}
          </div>
        </div>
        <button
          id="map-list-toggle-visible"
          modus-icon-button
          class="min-w-[1.75rem] text-gray-8 disabled:text-gray-6"
          [disabled]="!item.scan.hasFeature"
          (click)="changeItemVisibilityClicked.emit(item.scan); $event.stopPropagation()"
        >
          @if (item.scan.hiddenOnMap) {
            <md-icon class="!text-xl">visibility_off</md-icon>
          } @else {
            <md-icon class="!text-xl">visibility_on</md-icon>
          }
        </button>
        <button
          id="map-list-goto"
          modus-icon-button
          class="min-w-[1.75rem] text-gray-8 disabled:text-gray-6"
          [disabled]="!item.scan.hasFeature"
          (click)="zoomToItemClicked.emit(item.scan); $event.stopPropagation()"
        >
          <md-icon class="!text-xl">location</md-icon>
        </button>
      </div>
    }
    @if (showScandataEmpty()) {
      <sd-scandata-empty [reason]="scandataEmptyReason()"></sd-scandata-empty>
    }
  </div>
</div>
